import { Table, Tag } from 'antd';
import 'dayjs/locale/es';
import { Link } from "react-router-dom";

const RankingTable = ({ user_id, ranking = [], ranking_name }) => {
  // Sort by points descending
  const sortedRanking = [...ranking].sort((a, b) => b.points - a.points);

  // Assign positions with ties (classic ranking)
  let lastPoints = null;
  let lastPosition = 0;
  const rankingWithPosition = sortedRanking.map((item, idx) => {
    if (item.points !== lastPoints) {
      lastPosition = idx + 1;
    }
    lastPoints = item.points;
    return { ...item, position: lastPosition };
  });

  // Top 10 (by position, not index)
  const top10 = [];
  let seenPositions = new Set();
  for (let i = 0; i < rankingWithPosition.length && top10.length < 10; i++) {
    if (!seenPositions.has(rankingWithPosition[i].position)) {
      seenPositions.add(rankingWithPosition[i].position);
    }
    top10.push(rankingWithPosition[i]);
  }

  // Find current user's row
  const userRow = rankingWithPosition.find(r => String(r.user_id) === String(user_id));
  const userInTop10 = userRow && top10.some(r => String(r.user_id) === String(user_id));

  // Prepare dataSource: if user is not in top 10, show them as first row
  let dataSource = [];
  if (userRow && !userInTop10) {
    dataSource = [
      { ...userRow, isCurrentUser: true, key: userRow.user_id },
      ...top10.map(r => ({
        ...r,
        isCurrentUser: String(r.user_id) === String(user_id),
        key: r.user_id,
      })),
    ];
  } else {
    dataSource = top10.map(r => ({
      ...r,
      isCurrentUser: String(r.user_id) === String(user_id),
      key: r.user_id,
    }));
  }

  const columns = [
    {
      title: 'Posición',
      dataIndex: 'position',
      key: 'position',
      render: (text, record) =>
        record.isCurrentUser ? <Tag color="magenta">{text}</Tag> : text,
    },
    {
      title: 'Usuario',
      dataIndex: 'user_id',
      key: 'user_id',
      render: (text, record) => {
        const fullName = `${record.user_name || ''} ${record.user_surname1 || ''}`.trim();
        return record.isCurrentUser
          ? <Tag color="magenta">{fullName} (Tú)</Tag>
          : (
            <Link to={`/users/${record.user_id}`}>
              {fullName}
            </Link>
          );
      },
    },
    {
      title: 'Puntos',
      dataIndex: 'points',
      key: 'points',
      render: (text, record) =>
        record.isCurrentUser ? <Tag color="magenta">{text}</Tag> : text,
    },
  ];

  return (
    <div className='col-10 col-md-7 m-auto'
      style={{overflowX: 'auto', maxWidth: '100%'}}>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowClassName={record => record.isCurrentUser ? 'ant-table-row-selected' : ''}
        bordered
        title={() => (
          <h3 className="text-center">
            Ranking - {ranking_name || ''}
          </h3>
        )}
      />
    </div>
  );
};

export default RankingTable;
